export const LEGAL_CONTACT = {
  email: 'info@altermirror.in',
  phone: '+91-9884110580',
  phoneTel: '+919884110580',
};

export const EULA_SECTIONS = [
  {
    title: 'Acceptance of Terms',
    paragraphs: [
      'By downloading, installing, or using Alter Salon ("App"), you agree to be bound by this End User Licence Agreement ("Agreement"). If you do not agree with these terms, please do not use the App.',
    ],
  },
  {
    title: 'Licence Grant',
    bullets: [
      'Limited, non-exclusive, non-transferable licence',
      'Personal, non-commercial use only',
      'No copying',
      'No modification',
      'No distribution',
      'No reverse engineering except where permitted by law',
    ],
  },
  {
    title: 'User Obligations',
    bullets: [
      'Comply with applicable laws',
      'Follow Play Store policies',
      'Do not misuse the App',
      'Do not disrupt services',
      'Do not access unauthorized data',
    ],
  },
  {
    title: 'Intellectual Property',
    bullets: [
      'All trademarks, logos and content remain property of the developer.',
      'This agreement does not transfer ownership.',
    ],
  },
  {
    title: 'Privacy & Data',
    bullets: [
      'Personal data may be collected according to the Privacy Policy.',
      'Continued use means consent.',
    ],
  },
  {
    title: 'Updates & Modifications',
    bullets: [
      'Updates and new features may be released.',
      'Continued use after updates means acceptance.',
    ],
  },
  {
    title: 'Termination',
    bullets: [
      'Licence remains active until terminated.',
      'Access may be suspended for violations.',
    ],
  },
  {
    title: 'Disclaimer of Warranties',
    paragraphs: ['The App is provided "AS IS" without warranties.'],
  },
  {
    title: 'Limitation of Liability',
    paragraphs: [
      'The developer is not liable for damages arising from use or inability to use the App.',
    ],
  },
  {
    title: 'Governing Law',
    bullets: ['Laws of India', 'Jurisdiction: Bengaluru, Karnataka'],
  },
];

export const EULA_SUMMARY =
  'By installing this app, you agree to a limited licence for personal use, compliance with applicable laws, and acceptance of our Privacy Policy.';

export const PRIVACY_SECTIONS = [
  {
    title: 'Information We Collect',
    subsections: [
      {
        title: 'Personal Information',
        bullets: ['Name', 'Email', 'Phone Number', 'Registration details'],
      },
      {
        title: 'Usage Information',
        bullets: ['App activity', 'Device information', 'IP address', 'Log files'],
      },
      {
        title: 'Cookies',
        bullets: ['Cookies and similar technologies may be used.'],
      },
    ],
  },
  {
    title: 'How We Use Information',
    bullets: [
      'Improve the app',
      'Personalize experience',
      'Customer support',
      'Notifications',
      'Legal compliance',
      'Prevent misuse',
    ],
  },
  {
    title: 'Data Sharing',
    bullets: [
      'We never sell personal information.',
      'Information may be shared with hosting, analytics and support providers.',
      'Information may be disclosed if legally required.',
    ],
  },
  {
    title: 'Data Security',
    paragraphs: [
      'Industry-standard security practices are used, but no system is completely secure.',
    ],
  },
  {
    title: 'User Rights',
    bullets: [
      'Access your data',
      'Update your data',
      'Delete your data',
      'Opt out of marketing',
    ],
  },
  {
    title: "Children's Privacy",
    paragraphs: ['Not intended for children under 13.'],
  },
  {
    title: 'Policy Updates',
    paragraphs: ['Continued use means acceptance of updated policy.'],
  },
  {
    title: 'Contact',
    contact: true,
  },
];

export const PRIVACY_SUMMARY =
  'We respect your privacy. Personal data is collected only to improve app functionality and is never sold.';

export const TERMS_OF_SERVICE_SECTIONS = [
  {
    title: 'Acceptance of Terms',
    paragraphs: ['By using this App, you agree to these Terms.'],
  },
  {
    title: 'Eligibility',
    paragraphs: ['Users must be at least 13 years old.'],
  },
  {
    title: 'Use of the App',
    bullets: [
      'Lawful use only',
      'No hacking',
      'No exploitation',
      'Maintain account confidentiality',
    ],
  },
  {
    title: 'Content & Intellectual Property',
    paragraphs: ['All content and trademarks belong to the developer.'],
  },
  {
    title: 'Purchases & Payments',
    bullets: [
      'Some features require payment.',
      'Payments are processed through Google Play Store.',
      'Refunds follow Play Store policies.',
    ],
  },
  {
    title: 'Third-Party Services',
    paragraphs: [
      'Developer is not responsible for third-party availability or performance.',
    ],
  },
  {
    title: 'Termination',
    paragraphs: ['Access may be suspended for violations.'],
  },
  {
    title: 'Limitation of Liability',
    paragraphs: ['The App is provided "AS IS".'],
  },
  {
    title: 'Governing Law',
    bullets: ['Laws of India', 'Jurisdiction: Chennai, Tamil Nadu'],
  },
  {
    title: 'Contact',
    contact: true,
  },
];

export const TERMS_OF_SERVICE_SUMMARY =
  'Continued use of the App constitutes acceptance of these Terms of Service.';

export const FINAL_SUMMARY_SECTIONS = [
  {
    title: 'Licence Agreement',
    bullets: [
      'Limited licence',
      'No reverse engineering',
      'No unauthorized distribution',
    ],
  },
  {
    title: 'Privacy Policy',
    bullets: [
      'Personal information is never sold.',
      'Users can request updates or deletion.',
    ],
  },
  {
    title: 'Terms of Service',
    bullets: [
      'Lawful usage required.',
      'Payments handled securely via Play Store.',
      'Continued use implies acceptance.',
    ],
  },
  {
    title: 'Disclaimer',
    paragraphs: [
      'The App is provided "AS IS" without warranties. The developer shall not be liable for damages arising from use or inability to use the App.',
    ],
  },
  {
    title: 'Governing Law',
    bullets: ['India', 'Jurisdiction: Bengaluru, Karnataka'],
  },
  {
    title: 'Support',
    contact: true,
  },
];
